import axios from "../../axios";
import { devUrl } from "../../settings";

const state = {
  studies: [],
  studiesQuantity: null,
  studiesForSelect: null,
  studiesDeletionId: null
};

const getters = {
  studies(state) {
    return state.studies;
  },
  getStudiesQuantity(state) {
    return state.studiesQuantity;
  },
  getStudiesDeletingId(state) {
    return state.studiesDeletionId;
  },
  getStudiesForSelect(state) {
    return state.studiesForSelect;
  }
};

const mutations = {
  storeStudies(state, payload) {
    state.studies = payload.results;
    state.studiesQuantity = payload.studiesCount;
    state.studiesForSelect = payload.studiesForSelect;
  },
  storeStudyModalId(state, payload) {
    state.studiesDeletionId = payload;
  }
};

const actions = {
  async fetchStudies({ commit }, page) {
    let res = await axios.get(`/studies/?limit=5&offset=${5 * page - 5}`);

    const studiesForSelect = [];

    res.data.results.forEach(item => {
      let studyObj = {
        id: item.id,
        name: item.name
      };

      studiesForSelect.push(studyObj);
    });

    commit("storeStudies", {
      results: res.data.results,
      studiesCount: res.data.count,
      studiesForSelect
    });
  },
  postStudy({ dispatch }, formData) {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    console.log(formData);

    return axios
      .post("/studies/", formData, config)
      .then(() => {
        dispatch("fetchStudies", 1);
      })
      .catch(err => console.log(err));
  },
  sendStudyIdToModal({ commit }, id) {
    commit("storeStudyModalId", id);
  },
  deleteStudy({ dispatch }) {
    const token = localStorage.getItem("token");
    const id = state.studiesDeletionId;

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    axios
      .delete(`${devUrl}studies/${id}`, config)
      .then(() => {
        dispatch("fetchStudies", 1);
        dispatch("sendStudyIdToModal", null);
      })
      .catch(err => console.log(err));
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
